import React from 'react';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { Zap, ChevronRight } from 'lucide-react';

export const Hero = () => {
  return (
    <section id="home" data-testid="hero-section" className="pt-24 pb-20 px-6 relative min-h-[600px] bg-white">
      {/* Full width background image */}
      <div className="absolute inset-0 pt-16">
        <img
          src="https://static.prod-images.emergentagent.com/jobs/32261963-9d8c-4e92-9519-12d4f10bddcb/images/239ade9169a4915f3b5e7cc1e94b3048c4027b13e15a4bb0f32bee61fc4d565b.png"
          alt="Engineer inspecting CAD airplane model"
          className="w-full h-full object-cover object-center opacity-40"
          data-testid="hero-aircraft-image"
        />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(to right, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.8) 40%, rgba(255, 255, 255, 0.4) 70%, transparent 100%)' }}></div>
      </div>

      {/* Text content box */}
      <div className="container mx-auto relative z-10">
        <div className="max-w-2xl space-y-5 py-12">
          <Badge className="bg-orange-100 text-orange-700 border-orange-200">
            <Zap className="w-3 h-3 mr-1" />
            AI-Powered Aircraft Scanning
          </Badge>
          <h1 className="text-4xl md:text-5xl font-bold text-black leading-tight">
            The Foundational Intelligence
            <span className="bg-gradient-to-r from-orange-500 to-orange-600 bg-clip-text text-transparent"> AI Layer </span>
            for Aviation & Defense Inspection
          </h1>
          <p className="text-base text-gray-700 leading-relaxed">
            Our exterior scanning technology provides comprehensive diagnostics for all aviation sectors. Ensure your fleet maintains the highest standards with precision exterior analysis.
          </p>
          <div className="flex flex-wrap gap-3">
            <Button
              data-testid="hero-request-demo-btn"
              size="default"
              className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Request Demo <ChevronRight className="w-4 h-4 ml-1" />
            </Button>
            <Button
              data-testid="hero-watch-video-btn"
              size="default"
              variant="outline"
              className="border-orange-600 text-orange-600 hover:bg-orange-50"
              onClick={() => document.getElementById('platform')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Explore Platform
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
